<template>
  <v-container>
    <material-card>
      <v-layout px-3 slot="header">
        <v-flex my-4 pl-4 title align-center justify-center>Szablony wiadomości</v-flex>

        <v-spacer></v-spacer>

        <v-flex>
          <v-text-field
            prepend-icon="mdi-magnify"
            name="search"
            label="Wyszukaj"
            color="white"
            clearable
            v-model="search"
          ></v-text-field>
        </v-flex>
      </v-layout>

      <v-layout text-xs-right>
        <v-flex>
          <check-permission permissions="MAIL_TEMPLATE.ADD">
            <v-btn large color="error" @click="showAddModal">DODAJ SZABLON</v-btn>
          </check-permission>
        </v-flex>
      </v-layout>

      <material-table
        editPerm="MAIL_TEMPLATE.UPDATE"
        deletePerm="MAIL_TEMPLATE.DELETE"
        :headers="table.headers"
        :items="list"
        :actions="true"
        :hideActions="false"
        :total-count="count"
        :search="search"
        @pagination="reloadList"
        @add="showAddModal"
        @edit="showEditModal"
        @delete="showDeleteDialog"
      ></material-table>

      <material-dialog
        title="Potwierdź usunięcie"
        text="Czy napewno chcesz usunąć szablon?"
        :show="!!idToDelete"
        :id="idToDelete"
        @close="hideDeleteDialog"
        @confirm="remove"
      ></material-dialog>
    </material-card>

    <modal
      :show="showModal"
      :id="idToEdit"
      :edit="!!idToEdit"
      @close="hideModal"
      @save="saveTemplate"
      @update="updateTemplate"
    ></modal>
  </v-container>
</template>

<script>
import { mapState } from 'vuex';

import MaterialCard from '@/components/material/Card';
import MaterialDialog from '@/components/material/Dialog';
import MaterialTable from '@/components/material/Table';
import Modal from './modals/template.modal';
import { listMixin } from '@/mixins/list';

// @vuese
// Wyświetlanie listy szablonów wiadomości
// @group MailTemplates
export default {
  mixins: [
    listMixin('mailTemplates', {
      listError: 'Wystąpił błąd podczas pobierania listy szablonów.',
      getError: 'Wystąpił błąd podczas pobierania danych szablonu.',
      added: 'Dodano szablon.',
      addError: 'Nie udało się dodać szablonu.',
      updated: 'Zaktualizowano dane szablonu.',
      updateError: 'Nie udało się zaktualizować danych szablonu.',
      deleted: 'Usunięto szablon.',
      deleteError: 'Nie udało się usunąć szablonu.'
    })
  ],
  components: {
    MaterialCard,
    MaterialDialog,
    MaterialTable,
    Modal
  },
  methods: {
    // @vuese
    // Zapisuje szablon
    // @arg `template` - dane szablonu
    saveTemplate(template) {
      try {
        this.$store.dispatch('mailTemplates/add', { mailTemplate: this.deepClone(template) }).then(() => {
          this.notifySuccess('Dodano szablon.');
          this.hideModal();
        });
      } catch (error) {
        this.notifyError('Nie udało się dodać szablonu.');
      }
    },
    // @vuese
    // Aktualizuje obiekt
    // @arg `data` - dane Obiektu
    updateTemplate(data) {
      const id = data.id;
      data.id = undefined;
      try {
        this.$store.dispatch('mailTemplates/update', { id, mailTemplate: this.deepClone(data) }).then(() => {
          this.notifySuccess('Zaktualizowano dane szablonu.');
          this.hideModal();
        });
      } catch (error) {
        this.notifyError('Nie udało się zaktualizować danych szablonu.');
      }
    }
  },
  data() {
    return {
      search: '',
      table: {
        headers: [{ value: 'name', text: 'Nazwa szablonu', sortable: true }]
      }
    };
  }
};
</script>
